// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1yipH","title":"BackImages_title__2H6N_","images":"BackImages_images__2M-1V"};